import React, { useState } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import AsyncSelect from 'react-select/async';
import { customStyles } from '~/Styles/reactSelectStyles';
import { buscarBoletoDigitalizacao } from '~/Services/Service';

let debounceTimer = null;

const CamposBoleto = ({ boletoSelecionado, onChangeBoleto, codigoGrupoEmpresa, slotGE }) => {
  const [modo, setModo] = useState('B');

  const labelDe = (item) =>
    `(Boleto) ${item.codigo_boleto} | (Quadra/Lote) Q${item.quadra || '?'}/L${item.lote || '?'} | (Cliente) ${item.cliente_nome || '-'}`;

  const itemParaSelecionado = (item) => ({
    codigo: item.codigo_boleto,
    quadra: item.quadra,
    lote: item.lote,
  });

  const trocarModo = (novoModo) => {
    setModo(novoModo);
    onChangeBoleto(null);
  };

  const loadOptionsAssync = (modoBusca, minChars) => (termo, callback) => {
    if (debounceTimer) clearTimeout(debounceTimer);
    if (!termo || termo.length < minChars || !codigoGrupoEmpresa) {
      callback([]);
      return;
    }
    debounceTimer = setTimeout(async () => {
      try {
        const lista = await buscarBoletoDigitalizacao(modoBusca, termo, codigoGrupoEmpresa);
        const opcoes = (lista || []).map((item) => ({
          value: item.codigo_boleto,
          label: labelDe(item),
          item,
        }));
        callback(opcoes);
      } catch (_err) {
        callback([]);
      }
    }, 300);
  };

  const valorAtual = boletoSelecionado
    ? {
        value: boletoSelecionado.codigo,
        label: `Boleto ${boletoSelecionado.codigo} — Q${boletoSelecionado.quadra || '?'}/L${boletoSelecionado.lote || '?'}`,
      }
    : null;

  const configPorModo = {
    B: { label: 'Número do Boleto', placeholder: 'Digite o número...', minChars: 1 },
    Q: { label: 'Quadra', placeholder: 'Digite a quadra...', minChars: 1 },
    C: { label: 'Cliente (código ou nome)', placeholder: 'Digite código ou nome do cliente...', minChars: 2 },
  };

  const cfg = configPorModo[modo];

  const radios = (
    <>
      <Form.Label className="small mb-1">Buscar por</Form.Label>
      <div className="d-flex" style={{ gap: '16px' }}>
        <Form.Check
          type="radio"
          id="modo-boleto"
          label="Boleto"
          name="modo_busca_boleto"
          checked={modo === 'B'}
          onChange={() => trocarModo('B')}
          inline
        />
        <Form.Check
          type="radio"
          id="modo-quadra"
          label="Quadra/Lote"
          name="modo_busca_boleto"
          checked={modo === 'Q'}
          onChange={() => trocarModo('Q')}
          inline
        />
        <Form.Check
          type="radio"
          id="modo-cliente"
          label="Cliente"
          name="modo_busca_boleto"
          checked={modo === 'C'}
          onChange={() => trocarModo('C')}
          inline
        />
      </div>
    </>
  );

  return (
    <div>
      {slotGE ? (
        <Row>
          <Col md={6}>{slotGE}</Col>
          <Col md={6}>
            <Form.Group>{radios}</Form.Group>
          </Col>
        </Row>
      ) : (
        <Form.Group>{radios}</Form.Group>
      )}

      <Form.Group>
        <Form.Label className="small mb-1">{cfg.label}</Form.Label>
        <AsyncSelect
          key={modo}
          loadOptions={loadOptionsAssync(modo, cfg.minChars)}
          value={valorAtual}
          onChange={(opt) => onChangeBoleto(opt ? itemParaSelecionado(opt.item) : null)}
          placeholder={cfg.placeholder}
          isClearable
          isDisabled={!codigoGrupoEmpresa}
          noOptionsMessage={({ inputValue }) =>
            !codigoGrupoEmpresa
              ? 'Selecione um Grupo de Empresa primeiro'
              : inputValue && inputValue.length >= cfg.minChars
                ? 'Nenhum boleto encontrado'
                : `Digite ao menos ${cfg.minChars} caractere${cfg.minChars > 1 ? 's' : ''}`
          }
          loadingMessage={() => 'Buscando...'}
          styles={customStyles}
        />
      </Form.Group>

      {boletoSelecionado && (
        <small className="text-success d-block mt-1">
          ✓ Boleto {boletoSelecionado.codigo} — Q{boletoSelecionado.quadra || '?'}/L{boletoSelecionado.lote || '?'}
        </small>
      )}
    </div>
  );
};

export default CamposBoleto;
